/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { Width_400 } from '../../../../../../SharedModules/StyleConstant/StyleConstant';
import { cellRenderer } from '../../../../../../SharedModules/utilities/utilities';
import { textCustomComparator } from '../../../../../contactType/components/tableHead';
import * as Styles from '../../../../../Maintain/client/Components/StyleConstant';
import ResearchExistingCMS64SubTotalCellRender from '../components/ResearchExistingCMS64SubTotalCellRender';

// Custom Header Component
const MultiLineHeaderComponent = () => {
  return (
    <div style={{ whiteSpace: 'normal' }}>
      <div>Drug Rebate</div>
      <br />
      <div>Drug Rebate Quarter</div>
    </div>
  );
};
export const RESEARCH_CMS64_HEAD = [
  {
    headerName: 'Drug Rebate',
    headerComponentFramework: MultiLineHeaderComponent,
    field: 'name',
    sortable: false,
    cellRenderer: 'drugRebate',
    editable: false,
    minWidth: Width_400,
    maxLength: Styles.Length_255,
    wrapText: false,
    autoHeight: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    columnSpan: 3,
    cellClass: 'frr-ellipsis-text hide-content-cell',
    cellStyle: (params) => {
      if (params.colDef.field === 'name') {
        if (params && params.rowIndex == 7) {
          return {
            'border-right': 'none',
          };
        }
      }
      return {
        'border-right-color': Styles.BorderColor,
        display: 'flex',
        alignItems: 'center',
      };
    },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },

  {
    headerName: 'Qtr Ending',
    field: 'Q1',
    minWidth: 160,
    sortable: false,
    maxLength: Styles.Length_255,
    wrapText: true,
    autoHeight: true,
    wrapHeaderText: true,
    isTextColorRed: true,
    autoHeaderHeight: true,
    editable: false,
    cellStyle: (params) => {
      if (params.colDef.field === 'Q1') {
        if (params && params.rowIndex == 7) {
          return {
            'border-right': 'none',
          };
        }
      }
      return {
        'border-right-color': Styles.BorderColor,
        alignItems: 'right',
      };
    },
    resizable: false,
    exportOption: {
      enableValueFormatter: true,
      printWithCurrency: '$',
    },
    cellRenderer: cellRenderer,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Qtr Ending',
    field: 'Q2',
    minWidth: 160,
    sortable: false,
    editable: false,
    maxLength: Styles.Length_255,
    wrapText: true,
    autoHeight: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    isTextColorRed: true,
    cellStyle: (params) => {
      if (params.colDef.field === 'Q2') {
        if (params && params.rowIndex == 7) {
          return {
            'border-right': 'none',
          };
        }
      }
      return {
        'border-right-color': Styles.BorderColor,
        alignItems: 'right',
      };
    },
    exportOption: {
      enableValueFormatter: true,
      printWithCurrency: '$',
    },
    cellRenderer: cellRenderer,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Qtr Ending',
    field: 'Q3',
    sortable: false,
    editable: false,
    minWidth: 160,
    maxLength: Styles.Length_255,
    wrapText: true,
    autoHeight: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    isTextColorRed: true,
    cellStyle: (params) => {
      if (params.colDef.field === 'Q3') {
        if (params && params.rowIndex == 7) {
          return {
            'border-right': 'none',
          };
        }
      }
      return {
        'border-right-color': Styles.BorderColor,
        alignItems: 'right',
      };
    },
    resizable: false,
    exportOption: {
      enableValueFormatter: true,
      printWithCurrency: '$',
    },
    cellRenderer: cellRenderer,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Qtr Ending',
    field: 'Q4',
    sortable: false,
    minWidth: 160,
    editable: false,
    maxLength: Styles.Length_255,
    wrapText: true,
    autoHeight: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    isTextColorRed: true,
    cellStyle: (params) => {
      if (params.colDef.field === 'Q4') {
        if (params && params.rowIndex == 7) {
          return {
            'border-right': 'none',
          };
        }
      }
      return {
        'border-right-color': Styles.BorderColor,
        alignItems: 'right',
      };
    },
    exportOption: {
      enableValueFormatter: true,
      printWithCurrency: '$',
    },
    cellRenderer: cellRenderer,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Previous Quarters',
    field: 'Q5',
    sortable: false,
    minWidth: 180,
    maxLength: Styles.Length_255,
    wrapText: true,
    autoHeight: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    isTextColorRed: true,
    cellStyle: (params) => {
      if (params.colDef.field === 'Q5') {
        if (params && params.rowIndex == 7) {
          return {
            'border-right': 'none',
          };
        }
      }
      return {
        'border-right-color': Styles.BorderColor,
        alignItems: 'right',
      };
    },
    resizable: false,
    editable: false,
    exportOption: {
      enableValueFormatter: true,
      printWithCurrency: '$',
    },
    cellRenderer: cellRenderer,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      //  textCustomComparator: textCustomComparator,
    },
  },
  {
    headerName: 'Final Total',
    field: 'finalTotal',
    minWidth: 180,
    sortable: false,
    editable: false,
    maxLength: Styles.Length_255,
    wrapText: true,
    autoHeight: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    isTextColorRed: true,
    cellStyle: { 'border-right-color': Styles.BorderColor, textAlign: 'right' },
    exportOption: {
      enableValueFormatter: true,
      printWithCurrency: '$',
    },
    cellRenderer: cellRenderer,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textCustomComparator: textCustomComparator,
    },
  },
];
export const QUARTER_END_DATE_MAPPING = {
  Q1: '03/31/',
  Q2: '06/30/',
  Q3: '09/30/',
  Q4: '12/31/',
};
